import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AnalyticsService, SEOService } from '@box-core/services';
import { ThemingService } from '@box-core/services/theming.service';
import { SeoOptions, ThemePreference } from '@box-types';
import { getThemePreference } from '@box/utils';

@Component({
  selector: 'account-settings-theme',
  templateUrl: './account-settings-theme.component.html',
  styleUrls: ['./account-settings-theme.component.scss']
})
export class AccountSettingsThemeComponent implements OnInit {
  public themePreference: ThemePreference;

  constructor(
    private themingService: ThemingService,
    private analyticsService: AnalyticsService,
    private activatedRoute: ActivatedRoute,
    private seoService: SEOService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.setMetaTags();
    this.themePreference = getThemePreference();
  }

  public onThemePreferenceSelection(themePreference: ThemePreference): void {
    this.themingService.setThemePreference(themePreference);
    this.themePreference = themePreference;
    this.triggerAnalyticsEvent(themePreference);
  }

  private triggerAnalyticsEvent(themePreference: ThemePreference): void {
    const eventName = themePreference === 'system' ? 'click_system_default_mode' : `click_${themePreference}_mode`;
    this.analyticsService.addGACustomEvent(eventName, {});
  }

  private setMetaTags(): void {
    const options: SeoOptions = { title: this.activatedRoute.snapshot.data.breadcrumbName, url: this.router.url };
    this.seoService.setTags(options);
  }
}
